import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ContentLoader from 'react-content-loader'
import { DEFAULT_THEME } from '../../constants'

class PlaceholderLayout extends React.PureComponent {
  
  render() {
    const { theme, viewBox, preserveAspectRatio, speed } = this.props

    const isLight = ['light', 'white', ''].indexOf(theme) > -1
    const isNight = theme === 'night'
    const title = 'Loading...'
    const backgroundColor = isLight ? '#f3f3f3' : isNight ? '#373d5a' : '#444'
    const foregroundColor = isLight ? '#ecebeb' : isNight ? '#23273a' : '#292929'

    return (
      <ContentLoader
        title={title}
        speed={speed}
        viewBox={viewBox}
        backgroundColor={backgroundColor}
        foregroundColor={foregroundColor}
        preserveAspectRatio={preserveAspectRatio}
      >
        {this.props.children}
      </ContentLoader>
    )
  }

}

const mapStateToProps = (state) => ({
  theme: state.getIn(['settings', 'displayOptions', 'theme'], DEFAULT_THEME),
})

PlaceholderLayout.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.string.isRequired,
  viewBox: PropTypes.string.isRequired,
  preserveAspectRatio: PropTypes.string,
}

PlaceholderLayout.defaultProps = {
  speed: 1.25,
}

export default connect(mapStateToProps)(PlaceholderLayout)
